/* eslint-disable */
import React, { useState } from 'react';

export default function NewTempDetail({ datas, showError, interAdd, control, setValue, getValues, interAddErr, clearErrors }) {
    const [counts, setCounts] = useState({
        tempCount: 0,
        headerCount: 0,
        bodyCount: 0,
        footerCount: 0,
        varHeaderCount: 0,
        varBodyCount: 0,
    });
    const [headerType, setHeaderType] = useState("text");

    const handleInputChange = (field, maxCount) => (e) => {
        const value = e.target.value;
        setCounts((prev) => ({ ...prev, [`${field}Count`]: value.length }));
        setValue(field, value);
        if (value.length > maxCount) {
            showError(`Max Length of ${field.charAt(0).toUpperCase() + field.slice(1)} is ${maxCount}`);
        }
    };

    const addVariable = (field, maxVars, varCountKey) => {
        const currentCount = counts[varCountKey];
        if (currentCount >= maxVars) {
            showError(`You can add only ${maxVars} variables in ${field.charAt(0).toUpperCase() + field.slice(1)}`);
            return;
        }
        const currentValue = getValues(field) || '';
        const newValue = `${currentValue}{{${currentCount + 1}}}`;
        setValue(field, newValue);
        setValue('is_variable', "1");
        setCounts((prev) => ({ ...prev, [varCountKey]: currentCount + 1 }));
    };

    const renderFieldError = (field, maxCount) => {
        const error = interAddErr[field];
        if (error) {
            if (error.type === "required"){
                clearErrors(field)
                return showError(`The ${field} field is required`);
            } 
            if (error.type === "maxLength"){
                return `Max Length of ${field} is ${maxCount}`;
            } 
        }
        return null;
    };

    const HeaderBox = () => {
        return (
            <div className="header_teml">
                <label className="header_heading"><i className="fa-solid fa-tachograph-digital"></i> Header</label>
                <div className="header_enter_text_box">
                    {headerType === "text" ? (
                        <input {...interAdd("header", { onChange: handleInputChange("header", 512), })} className="form-control" placeholder="Enter Header Text" />
                    ) : (
                        <input
                            {...interAdd("header", {
                                onChange: handleInputChange("header", 512),
                                pattern: {
                                    value: /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/,
                                    message: "Enter a valid URL",
                                },
                            })}
                            className="form-control" placeholder="Enter Header URL"
                        />
                    )}
                    <div className="text-right">
                        <button className="btn btn-sm ad_var_btn" type="button" onClick={() => addVariable("header", 1, "varHeaderCount")}>
                            <i className="fa fa-plus"></i> Var
                        </button>
                    </div>
                </div>
                <p className="cer_cont">{counts.headerCount} / 512</p>
            </div>
        );
    };

    return (
        <div>
            <div className="header_teml">
                <label className="header_heading"><i className="fa-regular fa-address-card"></i> Template Name</label>
                <div className="header_enter_text_box">
                    <input
                        {...interAdd("template_name", { required: true, onChange: handleInputChange("temp", 512), })}
                        maxLength={512} className="form-control" placeholder="Enter Template Name"
                    />
                    {renderFieldError("template_name", 512)}
                </div>
                <p className="cer_cont">{512 - counts.tempCount} / 512</p>
            </div>

            <div className="header_teml">
                <label className="header_heading">
                    <i className="fa-solid fa-tachograph-digital"></i> Header Type
                </label>
                <div className="header_enter_text_box">
                    <select className="form-control"{...interAdd("header_type", { required: true, onChange: (e) => setHeaderType(e.target.value) })}>
                        <option value="text">Text</option>
                        <option value="image">Image</option>
                    </select>
                </div>
            </div>

            <HeaderBox />

            <div className="body_teml mt-2">
                <label className="header_heading">
                    <i className="fa-solid fa-file-lines"></i> Body
                </label>
                <div className="body_enter_text_box">
                    <textarea
                        {...interAdd("body", { required: true, onChange: handleInputChange("body", 1000) })}
                        maxLength={1000} className="form-control" placeholder="Enter Body"
                    />
                    {renderFieldError("body", 1000)}
                    <div className="text-right">
                        <button className="btn btn-sm ad_var_btn" type="button" onClick={() => addVariable("body", 20, "varBodyCount")}>
                            <i className="fa fa-plus"></i> Var
                        </button>
                    </div>
                </div>
                <p className="cer_cont">{1000 - counts.bodyCount} / 1000</p>
            </div>

            <div className="footer_teml mt-2">
                <label className="header_heading">
                    <i className="fa-solid fa-table-list"></i> Footer
                </label>
                <div className="footer_enter_text_box">
                    <input
                        {...interAdd("footer", { maxLength: 50, onChange: handleInputChange("footer", 50) })}
                        className="form-control" placeholder="Enter Footer" maxLength={50}
                    />
                    {renderFieldError("footer", 50)}
                </div>
                <p className="cer_cont">{50 - counts.footerCount} / 50</p>
            </div>
        </div>
    );
}